import * as api from '../api';
import { FETCH_ALL, CREATE, UPDATE, DELETE } from '../constants/actionTypes';

export const getLecturerProjects = () => async (dispatch) => {
    try {
        const response = await api.getLecturerProjects();
        dispatch({type: FETCH_ALL, payload: response});
    } catch (error) {
        console.log(error.message);
    }
}

export const createLecturerProjects = (project) => async (dispatch) => {
    try {
        const response = await api.createLecturerProjects(project);
        dispatch({type: CREATE, payload: response});
    } catch (error) {
        console.log(error);
    }
}

export const updateLecturerProject = (id, project) => async (dispatch) => {
    try {
        const {data} = await api.updateLecturerProject(id, project);
        dispatch({type: UPDATE, payload: data});
    } catch (error) {
        console.log(error);
    }
}

export const deleteLecturerProject = (id) => async (dispatch) => {
    try {
        await api.deleteLecturerProject(id);

        dispatch({type: DELETE, payload: id});
    } catch (error) {
        console.log(error);
    }
}